import react, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import Cadastro from '../../../../containers/forms/gerenciamento/Cadastro';

import { TelaModalLivre } from '../../../../helpers/TelaModal';

const CadastroGerente = (props) => {

    const [show, handleModal] = useState(true);

    return (
        <TelaModalLivre titulo="Gerenciamento"
        handleCloseModal={() => {
            handleModal();
            props.history.push('dashboard');
        }} 
        show={show} >
            <Cadastro />
        </TelaModalLivre>
    )
}

export default withRouter(CadastroGerente);